import api from "./api";

export const getPersonaNatural = async (idPersona) => {
    const response = await api.get(
        `/Persona/GetPersonaNaturalViewById?idPersona=${idPersona}`
    );

    return response.data.data;
}

export const getPersonaJuridica = async (idPersona) => {
    const response = await api.get(
        `/Persona/GetPersonaJuridicaViewById?idPersona=${idPersona}`
    );

    return response.data.data;
}

export const getLugaresTrabajo = async () => {
    const response = await api.get(
        "/Persona/GetsListLegalPersonByTypeAndName?idType=-1&name="
    );

    return response.data.data;
}

export const getsPersonaVinculacionView = async (idPersona) => {
    const response = await api.get(
        `/Persona/GetPersonasVinculacionesViewByIdPersona?idPersona=${idPersona}`
    );

    return response.data.data;
}

export const deletePersonaVinculacion = (idPersona, numero) =>
    api.delete(
        "/Persona/DeletePersonaVinculacion",{params: {idPersona, numero}}
    );

export const getsPersonaContactoView = async (idPersona) => {
    const response = await api.get(
        `/Persona/GetPersonasContactosViewByIdPersona?idPersona=${idPersona}`
    );

    return response.data.data;
}

export const deletePersonaContacto = (idPersona, numero) =>
    api.delete(
        "/Persona/DeletePersonaContacto",{params: {idPersona, numero}}
    )

export const getsPersonaDireccionView = async (idPersona) => {
    const response = await api.get(
        `/Persona/GetPersonasDireccionesViewByIdPersona?idPersona=${idPersona}`
    );

    return response.data.data;
}

export const deletePersonaDireccion = (idPersona, numero) =>
    api.delete(
        "/Persona/DeletePersonaDireccion",{params: {idPersona, numero}}
    )

export const getsPersonaDocumentoView = async (idPersona) => {
    const response = await api.get(
        `/Persona/GetPersonasDocumentosViewByIdPersona?idPersona=${idPersona}`
    );

    return response.data.data;
}
export const GetsPersonaRepresentanteViewById = async (idPersona) => {
    const response = await api.get(
        `/Persona/GetsPersonaRepresentanteViewById?idPersona=${idPersona}`
    );

    return response.data.data;
}
export const deletePersonaDocumento = (idPersona, numero) =>
    api.delete(
        "/Persona/DeletePersonaDocumento",{params: {idPersona, numero}}
    )
export const DeletePersonaRepresentante = (id) =>
    api.delete(
        "/Persona/DeletePersonaRepresentante",{params: {id}}
    )

export const getsPersonaAntecedenteView = async (idPersona) => {
    const response = await api.get(
        `/Persona/GetPersonasAntecedentesViewByIdPersona?idPersona=${idPersona}`
    );

    return response.data.data;
}

export const deletePersonaAntecedente = (idPersona, numero) =>
    api.delete(
        "/Persona/DeletePersonaAntecedente",{params: {idPersona, numero}}
    )

export const getsPersonaDocumentoByTipoYNumeroView = async (idTipoDocumento, numeroDocumento) => {
    const response = await api.get(
        "/Persona/GetsPersonaDocumentoByTipoYNumero",{params: {idTipoDocumento, numeroDocumento}}
    );

    return response.data.data;
}

export const getPersonaById = async (idPersona) => {
    const response = await api.get(
        `/Persona/GetPersonaById?idPersona=${idPersona}`
    );

    return response.data.data;
}

export const addPersonaVinculacion = (vinculacion) =>
    api.post(
        "/Persona/AddPersonaVinculacion",vinculacion
    )

export const postPersonaNaturalUpdateWithDetails = (dataPost) =>
    api.post(
        "/Persona/PostPersonaNaturalUpdateWithDetails",dataPost
    )

export const postPersonaJuridicaUpdateWithDetails = (dataPost) =>
    api.post(
        "/Persona/PostPersonaJuridicaUpdateWithDetails",dataPost
    )

export const getPersonaResumenBasicoViewByNumeroDocumentoYNombres = async (numeroDocumento, nombres, empresa) => {
    const response = await api.get(
        "/Persona/GetPersonasResumenBasicoViewByNumeroDocumentoYNombres",{params: {numeroDocumento, nombres, empresa}}
    );

    return response.data.data;
}

// tipoPersonaEntidad: 0 todos, 1 solo personas (clientes, familiares,
// proveedores y trabajadores), 2 solo personas juridicas de tipo entidad
// (colegios, bancos, eps...).
export const getsPersonasResumenViewByNumeroDocumentoYNombres = async (numeroDocumento, nombres, empresa, tipoPersonaEntidad) => {
    const response = await api.get(
        "/Persona/GetPersonasResumenViewByNumeroDocumentoYNombres",{params: {numeroDocumento, nombres, empresa, tipoPersonaEntidad}}
    );

    return response.data.data;
}

export const getsPersonasResumenView = async () => {
    const response = await api.get(
        "/Persona/GetPersonasResumenView"
    );

    return response.data.data;
}
export const GetsListPersonaRepresentanteByIdPersona = async (idPersona) => {
    const response = await api.get(
        `/Persona/GetsListPersonaRepresentanteByIdPersona?idPersona=${idPersona}`
    );

    return response.data.data;
}
export const getsColegio = async () => {
    const response = await api.get(
        "/Persona/GetsListLegalPersonByTypeAndName?idType=100&name="
    );

    return response.data.data;
}
export const getsListNaturalPersonByTypeAndName = async (idType, name) => {
    const response = await api.get(
        `/Persona/GetsListNaturalPersonByTypeAndName?idType=${idType}&name=${name}`
    );

    return response.data.data;
}
